export default __webpack_public_path__ + "static/media/Princess Ahana.135f9d04.jpg";